import { title } from "process"

const Theme = {
  body_background_color: '#3F7192',
  title_font: 'Nunito',
  text_font: 'Open Sans',
  logo_image_url: 'saco.png',
  token_url: 'saco.png',
  number_hidden: true,
  header_full_height: true,
  header_no_margin: true,
  header_no_border: true,
  logo_full_width: true,
  button_border_width: 1,
  button_color: '#8DC63F',
  button_hover_text_color: '#552613',
  button_radius: 100,
  button_outlined_border_color: '#552613',
  button_outlined_hover_border_color: '#552613',
  title_margin: '10px',
}

export default Theme
// https://app.clickup.com/t/86dtpzcn4